import { type ApiRequestOptions, apiJson } from "@/api/apiClient";

export interface CreateGraphFromDocumentsRequest {
	documentIds: string[];
	graphName?: string;
	graphDescription?: string | null;
	workspaceId?: string | null;
}

export interface GraphBuildJob {
	jobId: string;
	status: "pending" | "loading" | "formalizing" | "building" | "completed" | "failed";
	progress: number;
	createdAt: string;
	updatedAt: string;
	error?: string;
	graphId?: string;
}

export interface GraphBuildResults {
	jobId: string;
	graphId: string;
}

/**
 * Create a graph-building job from document IDs
 */
export const createGraphFromDocuments = async (
	request: CreateGraphFromDocumentsRequest,
	options?: ApiRequestOptions,
): Promise<{ jobId: string; status: string }> => {
	return apiJson<{ jobId: string; status: string }>("/graph-builder/jobs/from-documents", {
		method: "POST",
		body: JSON.stringify(request),
		signal: options?.signal,
	});
};

/**
 * Get the status of a graph-building job
 */
export const getGraphBuildJobStatus = async (jobId: string, options?: ApiRequestOptions): Promise<GraphBuildJob> => {
	return apiJson<GraphBuildJob>(`/graph-builder/jobs/status/${jobId}`, {
		signal: options?.signal,
	});
};

/**
 * Get the results of a completed graph-building job
 */
export const getGraphBuildJobResults = async (
	jobId: string,
	options?: ApiRequestOptions,
): Promise<GraphBuildResults> => {
	return apiJson<GraphBuildResults>(`/graph-builder/jobs/results/${jobId}`, {
		signal: options?.signal,
	});
};
